module.exports = __webpack_public_path__ + "img/zcm_logo.dad06e0a.png";